import Favicon from "@/public/Favicon.svg";
const NoData = ({message = 'Đang cập nhật ...'}) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <img src={Favicon} className="w-[9rem] h-[7.375rem] my-4" />
      <p className="text-[var(--theme-text-muted)] text-[0.75rem] text-center p-4">{message}</p>
    </div>
  );
}
export default NoData;